const INITIAL_CONTEXT = {
  actions: [],
  quickActions: [],
  setActions: (): any => [],
  setQuickActions: (): any => [],
};

export { INITIAL_CONTEXT };
